import { useDispatch, useSelector } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { Link, useNavigate } from 'react-router-dom'
import { logout } from 'src/store/actions/user'
import { MouseEvent } from 'react'
// import { useUser } from 'src/hooks/api'

import './UserAccount.sass'

const UserAccount = () => {
  const user = useSelector((s: { user: { user: {} } }) => s.user)

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleLogout = (e) => {
    e.preventDefault()
    dispatch(logout())
    navigate('/')
  }

  const handleMouseDown = (event: MouseEvent<HTMLElement>) => {
    if (event.currentTarget !== document.activeElement) return
    const t = event.currentTarget
    setTimeout(() => t.blur(), 0)
  }

  return (
    <div id="user-account" tabIndex={0}>
      <button className="user" onMouseDown={handleMouseDown}>
        <section className="data">
          <span className="icon icon-user" />
          <span className="name hide-desktop">
            {user.username || 'Anónimo'}
          </span>
        </section>
      </button>
      <section className="actions">
        <Link to="/soc/users/me" className="action profile">
          <span className="icon icon-profile-edit" />
          <span>
            <FormattedMessage id="profile" />
          </span>
        </Link>
        <div className="action logout" onClick={handleLogout}>
          <span className="icon icon-logout" />
          <span>
            <FormattedMessage id="logout" />
          </span>
        </div>
      </section>
    </div>
  )
}

export default UserAccount
